import React from 'react';
import { useCountUp } from '../hooks/useCountUp';

const CountUp = ({ value, duration = 2000, className = '' }) => {
  // Parse the value to separate number and suffix
  const match = value.match(/^(\d+)(.*)$/);
  const number = match ? match[1] : value;
  const suffix = match ? match[2] : '';

  const { displayValue, elementRef } = useCountUp(number, duration, suffix);

  return (
    <span ref={elementRef} className={className}>
      {displayValue}
    </span>
  );
};

export default CountUp;
